package devxertech.com.utils

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.silk.style.animation.Keyframes
import org.jetbrains.compose.web.css.px

val OpacityKeyframes = Keyframes {
    from { Modifier.opacity(1f) }
    to { Modifier.opacity(0f) }
}
val ShiftLeftKeyframes = Keyframes {
    from { Modifier.right(0.px) }
    to { Modifier.right(200.px) }
}
val ShiftRightKeyframes = Keyframes {
    from { Modifier.left(0.px) }
    to { Modifier.left(200.px) }
}

object Constants {
    const val FONT_FAMILY = "Inter"
    const val Top_Menu_Family = "Jost"
    const val ROBOTO_FONT = "Roboto"
    const val MONTSERRAT_FONT = "Montserrat"
     val HEADER_MAX_HEIGHT = 839.px
    const val MAX_HEIGHT = 917
    const val SLIDER_HEIGHT = 100
    val border_Radius = 10.px
    const val ABOUT_SEC_WIDTH = 1920
     val ABOUT_HEIGHT = 460.px
    const val CONTACT_SEC_HEIGHT = 565
    const val EMAIL_REGEX = "^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+.[A-Za-z0-9.-]"



//

}

object Res {
    object Image {
            const val LOGO = "/logo.svg"
            const val white_Logo = "/whiteLogo3.svg"
        const val angular_Logo = "angularlogo.svg"
        const val bootstrap_Logo = "bootstraplogo.svg"
        const val html_Logo= "htmllogo.svg"
        const val javaScript_Logo = "javascriptlogo.svg"
        const val laravel_Logo = "laravellogo.svg"
        const val nodesJs_Logo = "nodejslogo.svg"
        const val php_Logo = "phplogo.svg"
        const val vueJs_Logo = "vuejslogo.svg"
        const val header_Frame = "headerframe.svg"
        const val colored_logo = "coloredLogo.svg"
        const val ansible_logo = "ansible_logo.svg"
        const val blockchain_logo = "blockchain_logo.svg"
        const val cHesh_logo = "c_hesh_logo.svg"
        const val corda_logo = "corda_Logo.svg"
        const val docker_logo = "docker_logo.svg"
        const val elixir_logo = "elixir_logo.svg"
        const val ethereum_logo = "ethereum.svg"
        const val kotlin_logo = "kotlin_Logo.svg"
        const val mangoDB_logo = "mangoDB_logo.svg"
        const val mangoDB_tech = "mangoDB_tech.svg"
        const val mySQL_logo = "mySQL_logo.svg"
        const val postfressSQL_logo = "postgressSQL_logo.svg"
        const val postfressSQL_tech = "postgressSQL_tech.svg"
        const val puppet_logo = "puppet_Logo.svg"
        const val python_logo = "python_logo.svg"
        const val react_logo = "react.svg"
        const val swift_logo = "swift_Logo.svg"
        const val dot_bg = "dot_bg.svg"
        const val innovation_Solution = "innovative_solutions.svg"
        const val innovation_Solution_white = "innovative_solutions_white.svg"
        const val scalable_Solution = "scalable_solutions.svg"
        const val scalable_Solution_white = "scalable_solutions_white.svg"
        const val support = "support.svg"
        const val support_white = "support_white.svg"
        const val trace_record = "track_record.svg"
        const val trace_record_white = "track_record_white.svg"
        const val customer_centric = "customer_centeric_approach.svg"
        const val customer_centric_white = "customer_centeric_approach_white.svg"
        const val experienced_team = "experienced_team.svg"
        const val experienced_team_white = "experienced_team_white.svg"
        const val understand_patterb = "understand_pattern.svg"
        const val wire_frame = "wire_frame.svg"
        const val development_testing = "development_testing.svg"
        const val deployment = "deployment.svg"
        const val development_arrow = "developement_arrow.svg"
        const val android_logo = "android_logo.svg"
        const val bamboo_logo = "bamboo_logo.svg"
        const val flutter_logo = "flutter_logo.svg"
        const val git_logo = "git_logo.svg"
        const val gradle_logo = "gradle.svg"
        const val ios_logo = "ios_logo.svg"
        const val objC_logo = "objectC_logo.svg"
        const val jenkins_logo = "jenkin_logo.svg"
        const val selenium_logo = "selenium_logo.svg"
        const val anydesk_logo = "anydesk.svg"
        const val adobeXd_logo = "adobeXd_logo.svg"
        const val after_effect_logo = "aftereffect_logo.svg"
        const val figma_logo = "fimga_logo.svg"
        const val fresh_desk_logo = "fresh_desk_logo.svg"
        const val get_response_logo = "get_response_logo.svg"
        const val hadoop_logo = "hadoop_logo.svg"
        const val illustrator_logo = "illustrator_logo.svg"
        const val kafka_logo = "kafka_logo.svg"
        const val photoShop_logo = "photoshop_logo.svg"
        const val sketch_logo = "sketch_logo.svg"
        const val slack_logo = "slack_logo.svg"
        const val spark_logo = "spark_logo.svg"
        const val send_icon = "send_icon.svg"
        const val message_icon = "message_icon.svg"
        const val google_rating = "google_rating.svg"
        const val trustpilot_rating = "trustpilot.svg"
        const val faran = "faran.svg"
        const val jonathan = "jonathan.svg"
        const val matteo = "matteo.svg"
        const val peter = "peter.jpg"
        const val william = "william.jpg"
        const val henery = "Henery.jpg"
        const val dots = "dots.svg"
        const val software_bottom_sec = "sofware_bottom_box.svg"
        const val developer_arrow_down = "developement_arrow_down.svg"
        const val about_us = "about_us.svg"
        const val portfolio_left = "portfolio_left.svg"
        const val portfolio_middle = "portfolio_middle.svg"
        const val portfolio_right = "portfolio_right.svg"
        const val portfolio_bottom_scroll = "portfolio_bottom_scroll.svg"
        const val dx_logo = "dx_logo.svg"
        const val contact_Banner = "/contact_us_banner.svg"
        const val contact_arrow = "/arrow_box.svg"
        const val contact_responsive = "/contact_header-Res.svg"
        const val inverted_commas_starting = "inverted_commas_starting.svg"
        const val inverted_commas_ending = "inverted_commas_ending.svg"
        const val header_vector_first = "Heaedersectionvectorfirst.svg"
        const val header_vector_second = "headerTwoImage.svg"
        const val service_header = "service_header.svg"
        const val service_arrow = "ServiceArrow.svg"
        const val service_about = "ServiceAboutSec.svg"
        const val key_factor= "KeyFactor_1.svg"
        const val key_factor_2 = "KeyFactor_2.svg"
        const val key_factor_3 = "KeyFactor_3.svg"
        const val key_factor_4 = "KeyFactor_4.svg"
        const val key_factor_5 = "KeyFactor_5.svg"
        const val key_factor_6 = "KeyFactor_6.svg"
        const val workflow = "workflow.svg"
        const val team_1 = "Team_1.svg"
        const val team_2 = "Team_2.svg"
        const val team_3 = "Team_3.svg"
        const val team_4 = "Team_4.svg"
        const val team_vector = "TeamVector.svg"
        const val team_Vector2 = "TeamVector2.svg"
        const val elixir = "Elixir.svg"
        const val web_3 = "web3.svg"
        const val phonix = "phonix.svg"
        const val php = "PHP.svg"
        const val magneto= "Magneto.svg"
        const val joomia = "Joomla.svg"
        const val post_sql= "PostSQL.svg"
        const val mongo_new = "MongoNew.svg"
        const val node_new = "NodeJs.svg"
        const val nodeJs_tech = "nodesJS_tech.svg"
        const val python_new = "python 1.svg"
        const val mobile_header = "MobAppHeader.svg"
        const val dev_Header = "dev-Header.svg"
        const val mobile_about = "mobile_AboutSection.svg"
        const val mobile_structure = "Mobile Structure.svg"
        const val mob_react = "React_logo.svg"
        const val flutter = "flutter_2.svg"
        const val swift = "swift 1.svg"
        const val android = "Android_logo.svg"
        const val Ionic = "Object-logo.svg"
        const val kotlin= "Kotlin_logo.svg"
        const val kotlin_tech= "kotlin_tech.svg"
        const val ios= "Apple_logo.svg"
        const val obj_logo= "objective-c.1024x1024 1.svg"
        const val angular = "Angular.svg"
        const val dev_1= "dev_1.svg"
        const val dev_2= "dev_2.svg"
        const val dev_3= "dev_3.svg"
        const val dev_4= "dev_4.svg"
        const val dev_5= "dev_5.svg"
        const val dev_6= "dev_6.svg"
        const val devOps= "DevOps.svg"
        const val dev_about= "dev-OpsAbout.svg"
        const val dev_vector= "dev-Vector.svg"
        const val devOps_1= "docker.png.svg"
        const val devOps_2= "puppet.png.svg"
        const val devOps_3= "ansible.png.svg"
        const val devOps_4= "Chef.svg"
        const val devOps_5= "Git.svg"
        const val devOps_6= "gradle.png.svg"
        const val devOps_7= "selenium.png.svg"
        const val devOps_8= "bamboo.png.svg"
        const val devOps_9= "jenkins.png.svg"
        const val devOps_10= "Maven.svg"
        const val ui_Header= "ui_header.svg"
        const val kotlinText= "kotlin.svg"
        const val androidText= "android.svg"
        const val uiAbout= "uiAbout.svg"
        const val mbilUi= "mbl_ui.svg"
        const val webUi= "web_ui.svg"
        const val brandUi= "brandUi.svg"
        const val uiDesignSvg = "UiDesign.svg"
        const val xdLogo = "xdlogo.svg"
        const val psLogo = "pslogo.svg"
        const val aiLogo = "ailogo.svg"
        const val figmaLogo = "figmalogo.svg"
        const val sketchLogo = "sketchlogo.svg"
        const val aeLogo = "aelogo.svg"
        const val ai_Chatbot = "ai_chatbot.svg"
        const val ai_Development_about = "ai_development_about.svg"
        const val ai_Development_header = "ai_development_header.svg"
        const val chatgpt_Integration = "chatgpt_integration.svg"
        const val computerVision = "computerVision.svg"
        const val dataBaseLogo = "database.svg"
        const val deployAndMonitor_Logo = "deployandmonitor.svg"
        const val django_logo = "django_logo.svg"
        const val evaluation_logo = "evaluation.svg"
        const val laravelIcon = "laravel_logo.svg"
        const val machineLearning = "machine_learning.svg"
        const val modelDesign = "modeldesign.svg"
        const val netLogo = "net_logo.svg"
        const val nlpLogo = "nlp.svg"
        const val predective_analysis = "predective_analysis.svg"
        const val chatbot_About = "chatbot_about.svg"
        const val chatbot_Consult = "chatbot_consultation.svg"
        const val chatbot_ContactUs = "chatbot_contactus.svg"
        const val chatbot_Cost = "chatbot_cost.svg"
        const val chatbot_Design = "chatbot_design.svg"
        const val chatbot_Header = "chatbot_header.svg"
        const val chatbot_Integration = "chatbot_Integration.svg"
        const val chatbot_Multilanguage = "chatbot_multilanguage.svg"
        const val chatbot_Platform = "chatbot_platform.svg"
        const val chatbot_Support = "chatbot_support.svg"
        const val industry_Header = "industry_header.svg"
        const val industry_shaping = "Shaping-Industry.svg"
        const val industry_light_1 = "spotlight_1.svg"
        const val industry_light_2 = "spotlight_2.svg"
        const val industry_light_3 = "spotlight_3.svg"
        const val industry_light_4 = "spotlight_4.svg"
        const val industry_light_5 = "spotlight_5.svg"
        const val inovative_common = "Side-Image.svg"
        const val audience_1 = "audience_1.svg"
        const val audience_2 = "audience_2.svg"
        const val audience_3 = "audience_3.svg"
        const val audience_4 = "audience_4.svg"
        const val common_arrow = "common_arrow_couple.svg"

        const val health_header = "health_header.svg"
        const val health_system = "Health_System.svg"
        const val health_1 = "Health_1.svg"
        const val health_2 = "Health_2.svg"
        const val health_3 = "Health_3.svg"
        const val health_4 = "Health_4.svg"
        const val health_5 = "Health_5.svg"
        const val health_spot_1 = "Health_Spot_1.svg"
        const val health_spot_2 = "Health_Spot_2.svg"
        const val health_spot_3 = "Health_Spot_3.svg"
        const val health_spot_4 = "Health_Spot_4.svg"

        const val fintech_header = "Fintech_Header.svg"
        const val fintech_solution = "financial-about.svg"
        const val fintech_1 = "Fintech_1.svg"
        const val fintech_2 = "Fintech_2.svg"
        const val fintech_3 = "Fintech_3.svg"
        const val fintech_4 = "Fintech_4.svg"
        const val fintech_5 = "Fintech_5.svg"
        const val fintech_soft_1 = "Fintech_Soft_1.svg"
        const val fintech_soft_2 = "Fintech_Soft_2.svg"
        const val fintech_soft_3 = "Fintech_Soft_3.svg"
        const val fintech_soft_4 = "Fintech_Soft_4.svg"

        const val sport_header = "Sports_Header.svg"
        const val sport_service = "sport_about.svg"
        const val sport_1 = "Sport_Service_1.svg"
        const val sport_2 = "Sport_Service_2.svg"
        const val sport_3 = "Sport_Service_3.svg"
        const val sport_4 = "Sport_Service_4.svg"
        const val sport_5 = "Sport_Service_5.svg"
        const val sport_user_1 = "Sport-User_1.svg"
        const val sport_user_2 = "Sport-User_2.svg"
        const val sport_user_3 = "Sport-User_3.svg"
        const val sport_user_4 = "Sport-User_4.svg"

        const val career_header = "career_header.svg"
        const val career_about = "career_abouts.svg"
        const val career_succeed = "career_succeed.svg"
        const val career_empty = "career_empty.svg"

        const val portfolio_header ="portfolio_header.svg"
        const val safe_deposit_portfolio ="safe_desposit_portfolio.svg"
        const val zone360_portfolio ="zone360_portfolio.svg"
        const val varcity_portfolio ="varcity_portfolio.svg"
        const val tcld = "tcld_portfolio.svg"
        const val aura_network_porfolio = "aura_network_portfolio.svg"

        const val zone_header = "zoneHeader.svg"
        const val zone_icon = "zone_svg.svg"
        const val zone_arrow = "zone_Arrow.svg"
        const val zone_appview = "zoneAppView.svg"
        const val zone_png = "zone-png.png"
        const val zone_webview = "webView.svg"

        const val tcld_header = "tcld_header.svg"
        const val tcld_icon = "tcld_icon.svg"
        const val tcld_appview = "tcld_appview.svg"
        const val tcld_png = "tcld_png.png"
        const val tcld_webview = "tcld_webview.svg"

        const val varcity_header = "varcity-header.svg"
        const val varcity_logo = "varcity_logo.svg"
        const val varcity_appview = "varcity-appview.svg"
        const val varcity_png = "varcity-png.png"
        const val varcity_webview = "varcity-webview.svg"

        const val safe_header = "safe-header.svg"
        const val safe_icon = "safe-icon.svg"
        const val safe_appview = "safe-appview.svg"
        const val safe_png = "safe-png.png"
        const val safe_webview = "safe-webview.svg"

        const val aura_header = "aura-header.svg"
        const val aura_icon = "aura-icon.svg"
        const val aura_appview = "aura-appview.svg"
        const val aura_png = "aura_png.png"
        const val aura_webview = "aura-webview.svg"

        const val common_newarrow = "CommonArrow.svg"

//        Blogs
        const val blog_header = "blog.svg"
        const val blog_header_2 = "blog-header-2.svg"
        const val blog_1 = "blog-1.svg"
        const val blog_2 = "blog-2.svg"
        const val blog_3 = "blog-3.svg"
        const val blog_4 = "blog-4.svg"
        const val blog_5 = "blog-5.svg"
        const val blog_6 = "blog-6.svg"
        const val blog_ai = "AI-bussiness.svg"
        const val blog_area = "AI-area.svg"
        const val blog_community = "AI-community.svg"
        const val blog_arrow = "blog_arrow.svg"

        const val testimonial = "testimonial.webp"
        const val testimonial_2 = "modern.png"
        const val testimonial_3 = "test-4.jpg"










    }
    object Video{
        const val header_one_video = "headeroneVideo.mp4"
        const val header_two_video = "headertwovideo.mp4"
        const val header_three_video = "headerVideo3.mp4"
        const val header_four_video = "header_Video_4.mp4"
        const val header_five_video = "xeven_banner_video.mp4"
    }

}

